import { FocusError } from "focus-formik-error";
import { useTranslation } from "react-i18next";
import AutoSave from "views/hooks/AutoSave";

const AppointmentPatientFilter = ({ formState, patientQueryParametersOptions = [] }) => {
	const { t } = useTranslation();

	return (
		<form
			className="appointment-patient-filter w-100"
			onSubmit={formState?.handleSubmit}
			onReset={(e) => {
				formState?.handleReset(e);
				formState?.submitForm();
			}}
			noValidate>
			<FocusError formik={formState} />
			<AutoSave formik={formState} delay={400} />
			<fieldset>
				<legend className="visually-hidden">{`${t("titles.filter_form")}:`}</legend>
				<div className="input-group input-group-sm gap-2 bg-white px-2 py-1 flex-nowrap h-100 rounded border border-primary">
					{patientQueryParametersOptions.length > 1 && (
						<div className="input-group-append">
							<span className="hstack gap-1 flex-nowrap align-items-stretch h-100">
								<label
									htmlFor="appointmentPatientQueryParameterField"
									className="text-uppercase text-muted small mb-0 white-space-nowrap align-self-center">
									<small>
										<strong>Search by:</strong>
									</small>
								</label>
								<select
									id="appointmentPatientQueryParameterField"
									className="form-select form-select-sm fw-light text-capitalize text-uppercase border-0 bg-transparent ps-0 py-0 small"
									name="query_parameter"
									onChange={formState?.handleChange}
									value={formState?.values?.query_parameter || ""}>
									{patientQueryParametersOptions?.map(({ title, value }) => (
										<option value={value} key={value}>
											{title}
										</option>
									))}
								</select>
							</span>
						</div>
					)}
					<input
						onChange={formState?.handleChange}
						value={formState?.values?.query_value || ""}
						type="search"
						className="search-form-input form-control border-0 hide-clear text-truncate bg-transparent py-1"
						name="query_value"
						spellCheck="false"
						placeholder={`${t("fields.search")}...`}
					/>
					<div className="input-group-prepend hstack gap-2 flex-nowrap align-items-center text-primary">
						{formState?.values?.query_value && (
							<button
								type="reset"
								className="btn btn-link btn-sm p-2 rounded-0 text-decoration-none d-inline-flex align-items-center justify-content-center op-50 op-100-hover op-100-focus border-0"
								aria-label={t("actions.close")}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="0.75rem"
									height="0.75rem"
									fill="currentColor"
									viewBox="0 0 16 16">
									<path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
								</svg>
							</button>
						)}
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="1rem"
							height="1rem"
							viewBox="0 0 37.915 37.915"
							fill="currentColor">
							<path d="M16.7,0a16.7,16.7,0,1,0,16.7,16.7A16.716,16.716,0,0,0,16.7,0Zm0,30.312A13.615,13.615,0,1,1,30.312,16.7,13.63,13.63,0,0,1,16.7,30.312Z"></path>
							<g transform="translate(25.996 25.996)">
								<path
									d="M362.513,360.334l-8.837-8.837a1.541,1.541,0,0,0-2.179,2.179l8.837,8.837a1.541,1.541,0,0,0,2.179-2.179Z"
									transform="translate(-351.046 -351.046)"></path>
							</g>
						</svg>
					</div>
				</div>
			</fieldset>
		</form>
	);
};

export default AppointmentPatientFilter;
